import {
    addNewRowToTable,
    convertUniversalDateToPersianDate, DialogSize,
    RaikoBaseCardContainer,
    RaikoCardInfoTypeOne, RaikoCardInfoTypeOneItemGenerator,
    RaikoCardInfoTypeOneStatusTypes,
    RaikoChipTypes, RaikoCustomSelect, raikoCustomSelectItemGenerator,
    RaikoCustomSimpleChip,
    RaikoCustomTable, RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoGridThreeColumn, RaikoTableSearchContainer,
    RaikoTableTitleContainer,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {GameStageService} from "../../../serverService/gameService/GameStageService";
import {useDebounce} from "@uidotdev/usehooks";
import {GameStagesTypes, getGameStagesStatus} from "./GameStagesTypes";
import {ServerErrorHandler} from "../../../service/errorHandler/ServerErrorHandler";
import {css} from "@emotion/css";
import AddNewGameStage from "../../gameStages/addNewGameStage/AddNewGameStage";
import {useNavigate} from "react-router-dom";
import {RouteHelper} from "../../../route/RouteHelper";


export default function GameStages({gameId,gameTitle}) {

    let page = 0;
    const size = 20;

    const [selectDisplayType, setSelectDisplayType] = useState(false);
    const [gameStagesData, setGameStagesData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [numberOfItems, setNumberOfItems] = useState(0)

    const service = new GameStageService();

    const [gameStageTitle, setGameStageTitle] = useState("");
    const [gameStageStatus, setGameStageStatus] = useState(GameStagesTypes.ALL.id);

    const _gameStageTitle = useDebounce(gameStageTitle, 500);
    const _gameStageStatus = useDebounce(gameStageStatus, 100)

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getGameStagesDataFromServer()
        }
    }, [_gameStageTitle, _gameStageStatus]);


    function gameStagesTablePreparation(
        id,
        number,
        gameStageTitle,
        scoreWeight,
        maxScore,
        createdBy,
        createdAt,
        updatedBy,
        updatedAt,
        status
    ) {

        let statusChip

        if (status === GameStagesTypes.DRAFT.id || status === GameStagesTypes.ARCHIVED.id) {
            statusChip = <RaikoCustomSimpleChip title={getGameStagesStatus(status)} type={RaikoChipTypes.warning}/>
        } else if (status === GameStagesTypes.INACTIVE.id) {
            statusChip = <RaikoCustomSimpleChip title={getGameStagesStatus(status)} type={RaikoChipTypes.error}/>
        } else if (status === GameStagesTypes.ACTIVE.id) {
            statusChip = <RaikoCustomSimpleChip title={getGameStagesStatus(status)} type={RaikoChipTypes.success}/>
        } 


        return {
            id,
            number,
            gameStageTitle,
            scoreWeight,
            maxScore,
            createdBy,
            createdAt: convertUniversalDateToPersianDate(createdAt),
            updatedBy,
            updatedAt: convertUniversalDateToPersianDate(updatedAt),
            status: statusChip,
            statusPlace: status,
        }

    }

    function getGameStagesDataFromServer() {
        setTableLoading(true)
        service.getGameStageList(gameId, page, size, _gameStageTitle, _gameStageStatus)
            .then(response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setGameStagesData([])
                response.data.map((item, index) => {
                    setGameStagesData(prevState => [
                        ...prevState,
                        gameStagesTablePreparation(
                            item.id,
                            (page * size) + index + 1,
                            item.title,
                            item.scoreWeight,
                            item.maxScore,
                            item.createdBy,
                            item.createdAt,
                            item.updatedBy,
                            item.updatedAt,
                            item.status
                        )

                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        }).finally(_ => {
            setTableLoading(false)
        })

    }

    function handleChangePage(newPage) {
        page = newPage;
        getGameStagesDataFromServer()
    }

    function handleDeleteAllFilter() {
        setGameStageStatus(GameStagesTypes.ALL.id)
    }

    //add-new-gameStage
    const [openGameStageDialog, setOpenGameStageDialog] = useState(false)

    function handleOpenAddNewGameStageDialog() {
        setOpenGameStageDialog(true)
    }

    function handleCloseAddNewGameStageDialog() {
        setOpenGameStageDialog(false)
    }

    function handleAddNewRowToTable(item) {
        const _items = addNewRowToTable(
            gameStagesTablePreparation(
                item.id,
                1,
                item.gameStageTitle,
                item.scoreWeight,
                item.maxScore,
                item.createdBy,
                item.createdAt,
                item.updatedBy,
                item.updatedAt,
                item.status
            ),
            gameStagesData
        );
        setGameStagesData(_items)
    }

    //add-new-gameStage

    const navigate = useNavigate()


    function showGameStageDetails(gameStageId) {

        const stage = gameStagesData.find(
            (item) => item.id === gameStageId
        );

        navigate(
            RouteHelper.GameStageDetails.globalUrl
                .replace(":gameId", gameId)
                .replace(":gameStageId", gameStageId),
            {
                state: {
                    gameTitle: gameTitle,
                    gameStageTitle: stage?.gameStageTitle || ""
                },
                replace: false
            }
        );
    }


    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseAddNewGameStageDialog}
                open={openGameStageDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
                hasCloseButton={false}
            >
                <AddNewGameStage
                    gameId={gameId}
                    handleCloseDialog={handleCloseAddNewGameStageDialog}
                    handleAddNewGameStageToTable={handleAddNewRowToTable}
                />

            </RaikoDefaultDialogPage>
            <RaikoBaseCardContainer>
                <RaikoGridOneColumn>
                    <RaikoTableTitleContainer
                        title={"مراحل"}
                        hasCreateNewItem
                        handleCreateNewItem={handleOpenAddNewGameStageDialog}
                        amount={numberOfItems}
                        hasSelectDisplayType
                        selectDisplayType={selectDisplayType}
                        setSelectDisplayType={setSelectDisplayType}
                    />
                    <RaikoTableSearchContainer
                        labelText={"عنوان مرحله"}
                        value={gameStageTitle}
                        setValue={setGameStageTitle}
                        hasFilter
                        handleDeleteAllFilters={handleDeleteAllFilter}
                        filterStatus={
                            gameStageStatus.length > 0 && GameStagesTypes.ALL.id !== gameStageStatus
                        }
                    >
                        <RaikoGridOneColumn>
                            <RaikoCustomSelect
                                labelText={"وضعیت"}
                                value={gameStageStatus}
                                setValue={setGameStageStatus}
                                items={[
                                    raikoCustomSelectItemGenerator(GameStagesTypes.ALL.id, GameStagesTypes.ALL.title),
                                    raikoCustomSelectItemGenerator(GameStagesTypes.ACTIVE.id, GameStagesTypes.ACTIVE.title),
                                    raikoCustomSelectItemGenerator(GameStagesTypes.INACTIVE.id, GameStagesTypes.INACTIVE.title),
                                    raikoCustomSelectItemGenerator(GameStagesTypes.DRAFT.id, GameStagesTypes.DRAFT.title),
                                    raikoCustomSelectItemGenerator(GameStagesTypes.ARCHIVED.id, GameStagesTypes.ARCHIVED.title),
                                ]}
                            />
                        </RaikoGridOneColumn>

                    </RaikoTableSearchContainer>
                    <RaikoCustomTable
                        header={gameStageListHeader}
                        data={gameStagesData}
                        isLoading={tableLoading}
                        pageCount={pageCount}
                        selectDisplayType={selectDisplayType}
                        handlePaginationChange={handleChangePage}
                        rowClicked={showGameStageDetails}
                    >
                        <RaikoGridThreeColumn className={css`padding: 3px`}>
                            {
                                gameStagesData.map((item, index) => {
                                    return <RaikoCardInfoTypeOne
                                        key={index}
                                        title={item.gameStageTitle}
                                        status
                                        statusType={
                                            item.statusPlace === GameStagesTypes.DRAFT.id || item.statusPlace ===
                                            GameStagesTypes.ARCHIVED.id ? RaikoCardInfoTypeOneStatusTypes.WARNING :
                                                item.statusPlace === GameStagesTypes.INACTIVE.id ? RaikoCardInfoTypeOneStatusTypes.ERROR :
                                                    RaikoCardInfoTypeOneStatusTypes.SUCCESS
                                        }
                                        statusText={
                                            item.statusPlace === GameStagesTypes.DRAFT.id ? GameStagesTypes.DRAFT.title :
                                                item.statusPlace === GameStagesTypes.ARCHIVED.id ? GameStagesTypes.ARCHIVED.title :
                                                    item.statusPlace ===
                                                    GameStagesTypes.INACTIVE.id ? GameStagesTypes.INACTIVE.title :
                                                        GameStagesTypes.ACTIVE.title
                                        }
                                        items={[
                                            RaikoCardInfoTypeOneItemGenerator("سازنده", item.createdBy),
                                            RaikoCardInfoTypeOneItemGenerator("تاریخ ساخت", item.createdAt)
                                        ]}
                                        onClick={() => {
                                            showGameStageDetails(item.id)
                                        }}
                                    />
                                })
                            }

                        </RaikoGridThreeColumn>

                    </RaikoCustomTable>
                </RaikoGridOneColumn>
            </RaikoBaseCardContainer>
        </>

    )
}
const gameStageListHeader = [
    {
        id: "number",
        label: "#",
    },
    {
        id: "gameStageTitle",
        label: "عنوان مرحله"
    },
    {
        id: "scoreWeight",
        label: "وزن امتیاز"
    },
    {
        id: "maxScore",
        label: "حداکثر امتیاز"
    },
    {
        id: "createdBy",
        label: "سازنده"
    },
    {
        id: "createdAt",
        label: "تاریخ ساخت"
    },
    {
        id: "updatedBy",
        label: "ادمین"
    },
    {
        id: "updatedAt",
        label: "بروزرسانی"
    },
    {
        id: "status",
        label: "وضعیت"
    },
]